<template>
  <div id="app" class="mt-2_ font-sans">
    <div id="top-bar" class="sticky_ top-0 bg-gray-900 z-50 shadow-lg">
      <div class="flex flex-row items-center text-lg leading-normal py-3 md:py-2 px-2 sm:px-3  ">
        <div class="flex flex-shrink-0 items-center">
          <a class="hidden md:block text-showman no-underline text-2xl flex flex-start pb-1" href="/">
            <img src="https://res.cloudinary.com/showman/image/upload/c_fill,g_auto,h_65,q_auto,f_auto/v1576355554/logo_smooth_alt_new.png" class="h-10 md:h-16" alt="Showman">
          </a>
          <a class="block md:hidden text-showman no-underline text-2xl flex flex-start" href="/">
            <img src="https://res.cloudinary.com/showman/image/upload/h_65,q_auto,f_auto/v1671228923/Showman-Banner-Orange.png" class="h-10" alt="Showman">
          </a>
        </div>

        <div class="flex flex-grow flex-wrap items-center font-headline font-sans justify-end text-center">
          <a class="py-0.5 md:py-1 px-2 md:px-3 text-white no-underline hover:bg-white hover:text-black border border-white rounded-md md:text-xl mr-2" href="/shows">Find Shows</a>
          <a onclick="fathom.trackGoal('PPBJ1VUV', 0);" class="py-0.5 md:py-1 px-2 md:px-3 text-white no-underline hover:bg-black rounded-md text-base md:text-xl" href="/shows/#/new-show-signup">Create a Show</a>
          <a onclick="fathom.trackGoal('KOKIW9BU', 0);" href="/shows/#/judgeFinder" class="py-0.5 md:py-1 px-2 md:px-3 text-white no-underline hover:bg-black rounded-md text-base md:text-xl">Find Judges</a>
          <a href="/learn.html#/" class="py-0.5 md:py-1 px-2 md:px-3 text-white no-underline hover:bg-black rounded-md text-base md:text-xl">Learn</a>
          <a onclick="fathom.trackGoal('KOKIW9BU', 0);" href="/#/pricing" class="py-0.5 md:py-1 px-2 md:px-3 text-white no-underline hover:bg-black rounded-md text-base md:text-xl">Pricing</a>
          <!--a onclick="fathom.trackGoal('PPBJ1VUV', 0);" class="flex-0 btn-sm text-xs  md:text-lg bg-showman text-white ml-1" href="/shows/#/new-show-signup">Create a Show</a>-->
        </div>
      </div>
      <div class="relative bg-white border-t-4 border-b-4 border-showman z-100" v-if="showAnnouncement">
        <div class="mx-auto max-w-7xl px-3 py-3 sm:px-6 lg:px-8">
          <div class="pr-16 sm:px-16 sm:text-center">
            <p class="font-medium text-black">
              <span class="md:hidden font-bold">📣 Showman Judges is officially live!</span>
              <span class="hidden md:inline font-bold">📣 Showman Judges is officially live!</span>
              <svg viewBox="0 0 2 2" class="hidden mx-2 sm:inline h-0.5 w-0.5 fill-current" aria-hidden="true"><circle cx="1" cy="1" r="1" /></svg>
              <span class="inline sm:hidden">&nbsp;</span>
              <span>Help us grow by sharing with judges you know.</span>
              <span class="block sm:ml-2 sm:inline-block">
                <a href="/shows/#/judgeFinder" class="font-bold text-black underline">Find your next judge <span aria-hidden="true">&rarr;</span></a>
              </span>
            </p>
            <p class="mt-1 font-medium text-black">
              Are you a judge?
              <a class="link" href="/shows/#/judgeFinder">Claim your profile today!</a>
            </p>
          </div>
          <div class="absolute inset-y-0 right-0 flex items-start pr-1 pt-1 sm:items-start sm:pr-2 sm:pt-1">
            <button type="button" class="flex rounded-md p-2 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-white" @click="showAnnouncement = false">
              <span class="sr-only">Dismiss</span>
              <svg class="h-6 w-6 text-gray-900" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Top Section to announce something or for a contest-->
    <router-view class=""/>
    <Footer class="bg-white" aria-labelledby="footer-heading"></Footer>
  </div>
</template>

<script>
import Footer from '@/pages/marketing/Footer.vue'
export default {
  components: {
    Footer
  },
  data () {
    return {
      show_giveaway: false,
      showAnnouncement: true
    }
  },
  computed: {
    currentUser () {
      if (this.$store) {
        return this.$store.state.user ? this.$store.state.user : {}
      } else {
        return {}
      }
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style>
.newsletter .ml-form-embedBody {
  padding: 0px 0px 0px 0px !important;
}
</style>
